import { buildModelManager } from "../builder.js";
const DefaultShopifyLocationSelection = {
  __typename: true,
  id: true,
  activatable: true,
  active: true,
  address1: true,
  address2: true,
  addressVerified: true,
  city: true,
  country: true,
  countryCode: true,
  createdAt: true,
  deactivatable: true,
  deactivatedAt: true,
  deletable: true,
  fulfillsOnlineOrders: true,
  hasActiveInventory: true,
  hasUnfulfilledOrders: true,
  legacy: true,
  legacyResourceId: true,
  localPickupSettingsV2: true,
  name: true,
  phone: true,
  province: true,
  provinceCode: true,
  shipsInventory: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  suggestedAddresses: true,
  updatedAt: true,
  zipCode: true
};
const modelApiIdentifier = "shopifyLocation";
const pluralModelApiIdentifier = "shopifyLocations";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyLocationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyLocationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyLocationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyLocationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyLocationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyLocationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyLocationSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyLocationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyLocation does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyLocationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyLocationSelection,
  operations
);
export {
  DefaultShopifyLocationSelection,
  ShopifyLocationManager
};
//# sourceMappingURL=ShopifyLocation.js.map
